import React, { useEffect, useState } from "react";
import Layout from "../layout/index";
import axios from "axios";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { ROOT_API } from "../../api/config";
import { formatDate } from "../../utils/dates";
import "./style.scss";

// After Revolut's hosted checkout the user is redirected here. The webhook grants premium
// server-side; we poll /status a handful of times to reflect it (webhook may lag a second).
const PremiumSuccess = () => {
  const intl = useIntl();
  const selectedLocale =
    useSelector((state) => state.lang.value) ||
    localStorage.getItem("lang") ||
    "hr";
  const locale = selectedLocale === "en" ? "en-US" : "hr-HR";

  const [state, setState] = useState("processing"); // processing | done | timeout
  const [until, setUntil] = useState(null);

  useEffect(() => {
    let alive = true;
    let tries = 0;

    const poll = async () => {
      tries += 1;
      try {
        // confirm reconciles the latest pending order with Revolut AND returns status — this
        // is the webhook backstop (Revolut can't reach localhost in sandbox).
        const res = await axios.post(
          `${ROOT_API}apis/billing/confirm`,
          { order_id: localStorage.getItem("pending_order_id") || undefined },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        const data = res?.data?.data;
        if (alive && data?.premium) {
          setUntil(data.premium_until);
          setState("done");
          localStorage.removeItem("pending_order_id");
          return;
        }
      } catch (e) {
        /* keep polling */
      }
      if (!alive) return;
      if (tries >= 8) {
        setState("timeout");
        return;
      }
      setTimeout(poll, 2000);
    };

    poll();
    return () => {
      alive = false;
    };
  }, []);

  return (
    <Layout>
      <div className="premium">
        <div className="container">
          <section className="premium__result">
            {state === "processing" && (
              <>
                <div className="premium__spinner" />
                <h1 className="premium__title">
                  {intl.formatMessage({ id: "premium_success_processing_title" })}
                </h1>
                <p className="premium__lead">
                  {intl.formatMessage({ id: "premium_success_processing" })}
                </p>
              </>
            )}
            {state === "done" && (
              <>
                <img
                  className="premium__result-art"
                  src={`${process.env.PUBLIC_URL}/assets/mascot/beaver-lantern.png`}
                  alt=""
                  aria-hidden="true"
                />
                <h1 className="premium__title">
                  {intl.formatMessage({ id: "premium_success_done_title" })}
                </h1>
                <p className="premium__lead">
                  {intl.formatMessage(
                    { id: "premium_success_done" },
                    { date: until ? formatDate(until, locale) : "" }
                  )}
                </p>
                <div className="premium__benefits">
                  <p className="premium__benefits-title">
                    {intl.formatMessage({ id: "premium_success_benefits_title" })}
                  </p>
                  <ul>
                    <li>{intl.formatMessage({ id: "premium_feat_instant" })}</li>
                    <li>{intl.formatMessage({ id: "premium_feat_channels" })}</li>
                  </ul>
                </div>
                <p className="premium__invoice-note">
                  {intl.formatMessage({ id: "premium_success_invoice" })}
                </p>
                <Link to="/register-service" className="btn-cta">
                  {intl.formatMessage({ id: "premium_success_cta" })}
                </Link>
              </>
            )}
            {state === "timeout" && (
              <>
                <h1 className="premium__title">
                  {intl.formatMessage({ id: "premium_success_pending_title" })}
                </h1>
                <p className="premium__lead">
                  {intl.formatMessage({ id: "premium_success_timeout" })}
                </p>
                <Link to="/pocetna" className="btn-cta">
                  {intl.formatMessage({ id: "premium_back_dashboard" })}
                </Link>
              </>
            )}
          </section>
        </div>
      </div>
    </Layout>
  );
};

export default PremiumSuccess;
